module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"footer":"Copyright {year} by Career Support - All Rights Reserved"},"id":{"footer":"Hak Cipta {year} oleh Career Support – Hak Cipta dilindungi oleh Undang-Undang"}}')
  delete Component.options._Ctor
}
